export enum AssetsPaths {
  LOGOS = 'assets/images/logos',
}
